import axios from "axios";

export const orderEndpoints = (builder) => ({
    getOrders: builder.query({
        query: ({ userGroup, limit }) => ({ url: `/orders?userGroup=${userGroup}&limit=${limit}`, method: 'get' }),
        providesTags: ['Orders'],
    }),
    getOrdersAggregate: builder.query({
        query: ({ userGroup, liveData, provider, startDate, endDate, status, userId }) => ({
            url: `/orders/aggregate?userGroup=${userGroup}`
                + `&liveData=${liveData}`
                + `&provider=${encodeURIComponent(provider)}`
                + `&startDate=${encodeURIComponent(startDate || "")}`
                + `&endDate=${encodeURIComponent(endDate || "")}`
                + `${status ? `&status=${encodeURIComponent(status)}` : ""}`
                + `${userId ? `&userId=${encodeURIComponent(userId)}` : ""}`,
            method: 'get',
        }),
        providesTags: ['Orders'],
    }),
    getOrder: builder.query({
        query: (id) => ({ url: `/orders/${id}`, method: 'get' }),
        providesTags: ['Orders'],
    }),
    createOrder: builder.mutation({
        query: (order) => ({ url: `/orders`, method: 'post', body: order }),
        invalidatesTags: ['Orders'],
    }),
    downloadOrdersReport: builder.mutation({
        query: ({ userGroup, liveData, userId, provider, startDate, endDate, status, format }) => ({
            url: `/orders/report/${format}?userGroup=${userGroup}`
                + `&liveData=${liveData}`
                + `${userId ? `&userId=${userId}` : ""}`
                + `&provider=${provider || ""}`
                + `&startDate=${startDate || ""}`
                + `&endDate=${endDate || ""}`
                + `&status=${status || ""}`,
            method: 'post'
        }),
    }),
    submitOrdersHistoryExport: builder.mutation({
        query: (filters = {}) => {
            const queryParams = new URLSearchParams();

            Object.entries(filters).forEach(([key, value]) => {
                if (value === undefined || value === null || value === "") {
                    return;
                }

                queryParams.append(key, value);
            });

            const queryString = queryParams.toString();

            return {
                url: `/orders/history/export${queryString ? `?${queryString}` : ""}`,
                method: 'post',
                body: filters,
            };
        },
    }),
    pollOrdersHistoryExport: builder.mutation({
        async queryFn({ jobId, offset = 0, limit = 500 } = {}) {
            try {
                const response = await axios.get(`/orders/history/export/${jobId}`, {
                    params: { offset, limit },
                    validateStatus: () => true,
                });

                if (response.status === 200 || response.status === 202) {
                    return {
                        data: {
                            status: response.status,
                            payload: response.data,
                        },
                    };
                }

                return {
                    error: {
                        status: response.status,
                        data: response.data?.error || response.statusText || "Orders export failed",
                    },
                };
            } catch (error) {
                return {
                    error: {
                        status: error?.response?.status,
                        data: error?.response?.data?.error || error?.message || "Orders export failed",
                    },
                };
            }
        },
    }),
    updateOrder: builder.mutation({
        query: ({ id, ...order }) => ({ url: `/orders/${id}`, method: 'patch', body: order }),
        invalidatesTags: ['Orders'],
    }),
    cancelOrder: builder.mutation({
        query: ({ id, ...order }) => ({ url: `/orders/${id}`, method: 'delete', body: order }),
        invalidatesTags: ['Orders'],
    }),
    approveOrder: builder.mutation({
        query: ({ id, ...order }) => ({ url: `/orders/${id}`, method: 'post', body: order }),
        invalidatesTags: ['Orders'],
    }),
})
